import React from "react";
import { Clock } from "lucide-react";

const STATE_STYLE = {
  green:  { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-200", dot: "bg-emerald-500", label: "On Track" },
  yellow: { bg: "bg-amber-100",   text: "text-amber-900",   border: "border-amber-300",   dot: "bg-amber-500",   label: "Due Soon" },
  red:    { bg: "bg-rose-100",    text: "text-rose-900",    border: "border-rose-300",    dot: "bg-rose-500",    label: "Overdue" },
};

const formatDelta = (iso) => {
  if (!iso) return "";
  const ms = new Date(iso).getTime() - Date.now();
  const absHours = Math.abs(ms) / 3_600_000;
  const sign = ms >= 0 ? "in" : "";
  const suffix = ms >= 0 ? "" : " ago";
  if (absHours < 1) {
    const m = Math.max(1, Math.round(Math.abs(ms) / 60_000));
    return `${sign} ${m}m${suffix}`.trim();
  }
  if (absHours < 24) return `${sign} ${Math.round(absHours)}h${suffix}`.trim();
  return `${sign} ${Math.round(absHours / 24)}d${suffix}`.trim();
};

/**
 * SLA bubble.
 * Props:
 *   state    — 'green' | 'yellow' | 'red' | null/undefined → renders nothing
 *   dueIso   — ISO datetime string of follow_up_due (for tooltip + delta)
 *   compact  — true = small pill (Pipeline cards), false = larger pill
 *   testid   — optional override
 */
export default function SLABubble({ state, dueIso, compact = false, testid }) {
  if (!state) return null;
  const s = STATE_STYLE[state] || STATE_STYLE.green;
  const delta = formatDelta(dueIso);

  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${s.bg} ${s.text} ${s.border}`}
        title={`${s.label}${delta ? ` — ${delta}` : ""}`}
        data-testid={testid || `sla-${state}`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
        {delta || s.label}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium border ${s.bg} ${s.text} ${s.border}`}
      data-testid={testid || `sla-${state}`}
    >
      <Clock className="h-3 w-3" />
      {s.label}{delta ? ` • ${delta}` : ""}
    </span>
  );
}
